"use strict";import{tag as l}from"../custom-tag.js";export function instructorLedIcon({height:h=16,width:a=16,hidden:r=!1,title:t="Instructor led"}={}){return l`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${a}
      height=${h}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <path
        fill="currentColor"
        d="M16.2 8.025H21a.225.225 0 0 0 .225-.225V3.6A.225.225 0 0 0 21 3.375h-.975V3h-.45v.375h-1.95V3h-.45v.375H16.2a.225.225 0 0 0-.225.225v4.2a.225.225 0 0 0 .225.225m.225-4.2h.75V4.2h.45v-.375h1.95V4.2h.45v-.375h.75v.75h-4.35zm0 1.2h4.35v2.55h-4.35zm-7.05 2.85a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0m4.8 0a2.175 2.175 0 1 1-4.35 0 2.175 2.175 0 0 1 4.35 0"
      />
      <path
        fill="currentColor"
        d="M2.775 16.275v3.6A.225.225 0 0 0 3 20.1h2.4a.225.225 0 0 0 .213-.154l.75-2.246h11.274l.75 2.246a.225.225 0 0 0 .213.154H21a.225.225 0 0 0 .225-.225V9h-.45v5.837h-4.95v-1.423A2.1 2.1 0 0 0 13.8 11.25h-3.6a2.1 2.1 0 0 0-2.025 2.164v1.423h-4.95V4.178a.365.365 0 0 1 .375-.353H15v-.45H3.6a.815.815 0 0 0-.825.803zm18 3.375h-2.013l-.65-1.95H20.4c.13 0 .259-.032.375-.092zm-12.15-6.236A1.65 1.65 0 0 1 10.2 11.7h3.6a1.65 1.65 0 0 1 1.575 1.714v1.423h-6.75zm-5.4 2.861v-.988h17.55v1.61a.365.365 0 0 1-.375.353H3.6a.365.365 0 0 1-.375-.353zm0 1.333c.116.06.244.091.375.092h2.289l-.651 1.95H3.225z"
      />
    </svg>
  `}
//# sourceMappingURL=instructorLed.js.map
